"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.members = exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/customer/members");
const _usergroupListReducer = require("../../modules/usergroup/list/reducers");
const _usergroupInviteReducer = require("../../modules/usergroup/invite/reducers");
const usergroupListReducer = _usergroupListReducer.default('customer/members');
const usergroupInviteReducer = _usergroupInviteReducer.default('customer/members');
exports.initialState = Object.assign(Object.assign({}, usergroupListReducer.initialState), { invite: Object.assign({}, usergroupInviteReducer.initialState), moveUserModal: false, moveStatus: 'STANDBY' });
//#endregion
//#region LENS
const inviteLens = monocle.Lens.fromProp('invite');
const methods = Object.assign({}, usergroupListReducer.methods);
exports.methods = methods;
methods[Actions.CLEAR_STATE] = () => (Object.assign({}, exports.initialState));
//#region move
methods[Actions.MOVE_USER_TO_USER_GROUP] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'STANDBY', moveUserModal: !state.moveUserModal }));
methods[Actions.MOVE_USER_TO_USER_GROUP_SAVE_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'SAVING' }));
methods[Actions.MOVE_USER_TO_USER_GROUP_SAVE_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'FAILED' }));
methods[Actions.MOVE_USER_TO_USER_GROUP_SAVE_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'SAVED', selectedUsers: state.moveUserModal ? [] : state.selectedUsers, selectedGroups: state.moveUserModal ? [] : state.selectedGroups, moveUserModal: false }));
//#endregion
const handleInvite = (action) => (state) => {
    const fn = usergroupInviteReducer.methods[action.type];
    if (fn) {
        return inviteLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleState = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
function members(state, action) {
    return fp.function.compose(handleInvite(action), handleState(action))(state);
}
exports.members = members;
//# sourceMappingURL=members.js.map